<template>
  <div class="container-sm bg-gray-100 mb-5 p-2">
    <div class="flex justify-center">
     <loading
                 :height="15"
                 color="#fff"
                 class="static"
                 :active="isLoading"
                 loader="dots"
                 :can-cancel="true"
                 :is-full-page="false"
                />
    </div>
    <div>
      <router-link type="button" class="hover:underline block text-left" to="/">
        <svg
          class="h-8 w-8 fill-current text-blue-900"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="274.835 394.86 54.965 55.15"
        >
          <defs />
          <path
            d="M302.4 395.823c14.752.013 26.694 12.004 26.695 26.805.001 14.592-12.041 26.517-26.753 26.495-14.737-.023-26.754-11.98-26.684-26.551.072-14.873 11.958-26.763 26.742-26.749zm.342 32.534h2.447c3.522 0 7.044.033 10.565-.013 2.327-.03 3.413-1.138 3.479-3.442.039-1.364.033-2.731.003-4.096-.057-2.537-.978-3.536-3.514-3.605-2.801-.076-5.605-.022-8.408-.024-1.471-.001-2.942 0-4.571 0 0-1.899.247-3.457-.079-4.885-.254-1.114-1.01-2.527-1.934-2.949-.783-.357-2.422.2-3.171.899-3.518 3.284-6.88 6.737-10.254 10.171-1.618 1.646-1.652 3.053-.056 4.689 3.413 3.497 6.829 6.997 10.403 10.326.73.68 2.361 1.107 3.203.755.868-.363 1.601-1.754 1.812-2.811.3-1.513.075-3.132.075-5.015z"
          />
        </svg>
      </router-link>

      <div class="container bg-white rounded-lg mt-3 p-2 box-shadow flex-col">
        <p class="w-full text-center text-2xl mb-2">Coberturas</p>
        <p class="w-full text-center text-xl">
          Seleccione las coberturas que desees contratar.
        </p>
      </div>

      <div
        v-if="showAP"
        class="container bg-white rounded-lg mt-5 p-3 box-shadow"
      >
        <svg
          @click="hideAP"
          class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 125.445 595.28 590"
        >
          <defs />
          <path
            d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
          />
          <path
            d="M215.788 488.478c-10.959 8.219-26.506 5.998-34.725-4.961-6.614-8.819-6.614-20.945 0-29.764l99.213-99.213c9.645-9.454 25.08-9.454 34.725 0l99.213 99.213c8.219 10.959 5.998 26.506-4.961 34.725-8.819 6.614-20.945 6.614-29.764 0l-81.851-81.603-81.851 81.851.001-.248z"
          />
        </svg>
        <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-2">
          Accidentes personales
        </p>
        <p class="text-gray-600 text-center text-lg lg:text-xl">
          Selecciona la cantidad que deseas recibir de beneficio
        </p>

        <div class="w-full p-2 text-center mt-2 mb-2">
          <v-select
          :searchable="false"
            v-model="selectedAPCoverage"
            class="w-full shadow appearance-none border rounded text-grey-darker"
            :options="selectAPOptions"
            :placeholder="'Seleccione la suma asegurada'"
          >
            <template v-slot:no-options>
              <template> No hay resultados. </template>
            </template>
          </v-select>
        </div>

        <div v-if="selectedAPCoverage != null">
          <table
            v-if="selectedAPCoverage.value != null"
            class="mt-5 mb-5 text-left"
            style="width: 100%"
          >
            <tr
              v-for="benefit in benefitsAP.result[selectedAPCoverage.value]
                .benefits"
              :key="benefit.id"
            >
              <td class="text-xs lg:text-base text-gray-800">
                {{ benefit.name }}
              </td>
              <td
                class="text-xs lg:text-base text-gray-800"
                style="text-align: left"
              >
                {{ $filters.toCurrency(benefit.sum_assured) }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div
        v-if="showIC"
        class="container bg-white rounded-lg mt-5 p-3 box-shadow"
      >
        <svg
          @click="hideIC"
          class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 125.445 595.28 590"
        >
          <defs />
          <path
            d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
          />
          <path
            d="M215.788 488.478c-10.959 8.219-26.506 5.998-34.725-4.961-6.614-8.819-6.614-20.945 0-29.764l99.213-99.213c9.645-9.454 25.08-9.454 34.725 0l99.213 99.213c8.219 10.959 5.998 26.506-4.961 34.725-8.819 6.614-20.945 6.614-29.764 0l-81.851-81.603-81.851 81.851.001-.248z"
          />
        </svg>
        <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-3">
          Indemnización por Cáncer
        </p>
        <p class="text-gray-600 text-center text-lg lg:text-xl">
          Selecciona la cantidad que deseas recibir de beneficio
        </p>

        <div class="w-full p-2 text-center mt-2 mb-2">
          <v-select
          :searchable="false"
            v-model="selectedICCoverage"
            class="w-full shadow appearance-none border rounded text-grey-darker"
            :options="selectICOptions"
            :placeholder="'Seleccione la suma asegurada'"
          >
            <template v-slot:no-options>
              <template> No hay resultados. </template>
            </template>
          </v-select>
        </div>

        <div v-if="selectedICCoverage != null">
          <table
            v-if="selectedICCoverage.value != null"
            class="mt-5 mb-5 text-left"
            style="width: 100%"
          >
            <tr
              v-for="benefit in benefitsIC.result[selectedICCoverage.value]
                .benefits"
              :key="benefit.id"
            >
              <td class="text-xs lg:text-base text-gray-800">
                {{ benefit.name }}
              </td>
              <td
                class="text-xs lg:text-base text-gray-800"
                style="text-align: left"
              >
                {{ $filters.toCurrency(benefit.sum_assured) }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div
        v-if="showRH"
        class="container bg-white rounded-lg mt-5 p-3 box-shadow"
      >
        <svg
          @click="hideRH"
          class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 125.445 595.28 590"
        >
          <defs />
          <path
            d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
          />
          <path
            d="M215.788 488.478c-10.959 8.219-26.506 5.998-34.725-4.961-6.614-8.819-6.614-20.945 0-29.764l99.213-99.213c9.645-9.454 25.08-9.454 34.725 0l99.213 99.213c8.219 10.959 5.998 26.506-4.961 34.725-8.819 6.614-20.945 6.614-29.764 0l-81.851-81.603-81.851 81.851.001-.248z"
          />
        </svg>
        <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-3">
          Respaldo Hospitalario
        </p>
        <p class="text-gray-600 text-center text-lg lg:text-xl">
          Selecciona la cantidad que deseas recibir de beneficio
        </p>

        <div class="w-full p-2 text-center mt-2 mb-2">
          <v-select
          :searchable="false"
            v-model="selectedRHCoverage"
            class="w-full shadow appearance-none border rounded text-grey-darker"
            :options="selectRHOptions"
            :placeholder="'Seleccione la suma asegurada'"
          >
            <template v-slot:no-options>
              <template> No hay resultados. </template>
            </template>
          </v-select>
        </div>

        <div v-if="selectedRHCoverage != null">
          <table
            v-if="selectedRHCoverage.value != null"
            class="mt-5 mb-5"
            style="width: 100%"
          >
            <tr
              v-for="benefit in benefitsRH.result[selectedRHCoverage.value]
                .benefits"
              :key="benefit.id"
            >
              <td class="text-xs lg:text-base text-gray-800">
                {{ benefit.name }}
              </td>
              <td
                class="text-xs lg:text-base text-gray-800"
                style="text-align: left"
              >
                {{ $filters.toCurrency(benefit.sum_assured) }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div
        v-if="showIE"
        class="container bg-white rounded-lg mt-5 p-3 box-shadow"
      >
        <svg
          @click="hideIE"
          class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 125.445 595.28 590"
        >
          <defs />
          <path
            d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
          />
          <path
            d="M215.788 488.478c-10.959 8.219-26.506 5.998-34.725-4.961-6.614-8.819-6.614-20.945 0-29.764l99.213-99.213c9.645-9.454 25.08-9.454 34.725 0l99.213 99.213c8.219 10.959 5.998 26.506-4.961 34.725-8.819 6.614-20.945 6.614-29.764 0l-81.851-81.603-81.851 81.851.001-.248z"
          />
        </svg>
        <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-3">
          Indemnización por Enfermedades Graves
        </p>
        <p class="text-gray-600 text-center text-lg lg:text-xl">
          Selecciona la cantidad que deseas recibir de beneficio
        </p>

        <div class="w-full p-2 text-center mt-2 mb-2">
          <v-select
          :searchable="false"
            v-model="selectedIECoverage"
            class="w-full shadow appearance-none border rounded text-grey-darker"
            :options="selectIEOptions"
            :placeholder="'Seleccione la suma asegurada'"
          >
            <template v-slot:no-options>
              <template> No hay resultados. </template>
            </template>
          </v-select>
        </div>

        <div v-if="selectedIECoverage != null">
          <table
            v-if="selectedIECoverage.value != null"
            class="mt-5 mb-5 text-left"
            style="width: 100%"
          >
            <tr
              v-for="benefit in benefitsIE.result[selectedIECoverage.value]
                .benefits"
              :key="benefit.id"
            >
              <td class="text-xs lg:text-base text-gray-800">
                {{ benefit.name }}
              </td>
              <td
                class="text-xs lg:text-base text-gray-800"
                style="text-align: left"
              >
                {{ $filters.toCurrency(benefit.sum_assured) }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div
        v-if="showPI"
        class="container bg-white rounded-lg mt-5 p-3 box-shadow"
      >
        <svg
          @click="hidePI"
          class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 125.445 595.28 590"
        >
          <defs />
          <path
            d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
          />
          <path
            d="M215.788 488.478c-10.959 8.219-26.506 5.998-34.725-4.961-6.614-8.819-6.614-20.945 0-29.764l99.213-99.213c9.645-9.454 25.08-9.454 34.725 0l99.213 99.213c8.219 10.959 5.998 26.506-4.961 34.725-8.819 6.614-20.945 6.614-29.764 0l-81.851-81.603-81.851 81.851.001-.248z"
          />
        </svg>
        <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-3">
          Pérdida de Ingresos
        </p>
        <p class="text-gray-600 text-center text-lg lg:text-xl">
          Selecciona la cantidad que deseas recibir de beneficio
        </p>

        <div class="w-full p-2 text-center mt-2 mb-2">
          <v-select
          :searchable="false"
            v-model="selectedPICoverage"
            class="w-full shadow appearance-none border rounded text-grey-darker"
            :options="selectPIOptions"
            :placeholder="'Seleccione la suma asegurada'"
          >
            <template v-slot:no-options>
              <template> No hay resultados. </template>
            </template>
          </v-select>
        </div>

        <div v-if="selectedPICoverage != null">
          <table
            v-if="selectedPICoverage.value != null"
            class="mt-5 mb-5 text-left"
            style="width: 100%"
          >
            <tr
              v-for="benefit in benefitsPI.result[selectedPICoverage.value]
                .benefits"
              :key="benefit.id"
            >
              <td class="text-xs lg:text-base text-gray-800">
                {{ benefit.name }}
              </td>
              <td
                class="text-xs lg:text-base text-gray-800"
                style="text-align: left"
              >
                {{ $filters.toCurrency(benefit.sum_assured) }}
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div
        v-if="!showAP || !showIC | !showRH | !showIE || !showPI"
        class="container bg-white rounded-lg mt-5 p-5 box-shadow flex-col"
      >
        <div v-if="canContractAP">
          <div v-if="!showAP" class="w-full shadow-xs inline-flex items-center">
            <svg
              @click="hideAP"
              class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 125.445 595.28 590"
            >
              <defs />
              <path
                d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
              />
              <path
                d="M379.492 352.412c10.959-8.219 26.506-5.998 34.725 4.961 6.614 8.819 6.614 20.945 0 29.764l-99.213 99.213c-9.645 9.454-25.08 9.454-34.725 0l-99.213-99.213c-8.219-10.959-5.998-26.506 4.961-34.725 8.819-6.614 20.945-6.614 29.764 0l81.851 81.603 81.851-81.851-.001.248z"
              />
            </svg>
            <span
              @click="hideAP"
              class="cursor-pointer text-sm md:text-xl lg:text-2xl xl:text-2xl font-medium pl-2"
              >Accidentes Personales</span
            >
          </div>
        </div>

        <div v-if="canContractIC">
          <div v-if="!showIC" class="w-full shadow-xs inline-flex items-center">
            <svg
              @click="hideIC"
              class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 125.445 595.28 590"
            >
              <defs />
              <path
                d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
              />
              <path
                d="M379.492 352.412c10.959-8.219 26.506-5.998 34.725 4.961 6.614 8.819 6.614 20.945 0 29.764l-99.213 99.213c-9.645 9.454-25.08 9.454-34.725 0l-99.213-99.213c-8.219-10.959-5.998-26.506 4.961-34.725 8.819-6.614 20.945-6.614 29.764 0l81.851 81.603 81.851-81.851-.001.248z"
              />
            </svg>
            <span
              @click="hideIC"
              class="cursor-pointer text-sm md:text-xl lg:text-2xl xl:text-2xl font-medium pl-2"
              >Indemnización por Cáncer</span
            >
          </div>
        </div>

        <div v-if="canContractRH">
          <div v-if="!showRH" class="w-full shadow-xs inline-flex items-center">
            <svg
              @click="hideRH"
              class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 125.445 595.28 590"
            >
              <defs />
              <path
                d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
              />
              <path
                d="M379.492 352.412c10.959-8.219 26.506-5.998 34.725 4.961 6.614 8.819 6.614 20.945 0 29.764l-99.213 99.213c-9.645 9.454-25.08 9.454-34.725 0l-99.213-99.213c-8.219-10.959-5.998-26.506 4.961-34.725 8.819-6.614 20.945-6.614 29.764 0l81.851 81.603 81.851-81.851-.001.248z"
              />
            </svg>
            <span
              @click="hideRH"
              class="cursor-pointer text-sm md:text-xl lg:text-2xl xl:text-2xl font-medium pl-2"
              >Respaldo Hospitalario</span
            >
          </div>
        </div>

        <div v-if="canContractIE">
          <div v-if="!showIE" class="w-full shadow-xs inline-flex items-center">
            <svg
              @click="hideIE"
              class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 125.445 595.28 590"
            >
              <defs />
              <path
                d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
              />
              <path
                d="M379.492 352.412c10.959-8.219 26.506-5.998 34.725 4.961 6.614 8.819 6.614 20.945 0 29.764l-99.213 99.213c-9.645 9.454-25.08 9.454-34.725 0l-99.213-99.213c-8.219-10.959-5.998-26.506 4.961-34.725 8.819-6.614 20.945-6.614 29.764 0l81.851 81.603 81.851-81.851-.001.248z"
              />
            </svg>
            <span
              @click="hideIE"
              class="cursor-pointer text-sm md:text-xl lg:text-2xl xl:text-2xl font-medium pl-2"
              >Indemnización por Enfermedades Graves</span
            >
          </div>
        </div>

        <div v-if="canContractPI">
          <div v-if="!showPI" class="w-full shadow-xs inline-flex items-center">
            <svg
              @click="hidePI"
              class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 125.445 595.28 590"
            >
              <defs />
              <path
                d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"
              />
              <path
                d="M379.492 352.412c10.959-8.219 26.506-5.998 34.725 4.961 6.614 8.819 6.614 20.945 0 29.764l-99.213 99.213c-9.645 9.454-25.08 9.454-34.725 0l-99.213-99.213c-8.219-10.959-5.998-26.506 4.961-34.725 8.819-6.614 20.945-6.614 29.764 0l81.851 81.603 81.851-81.851-.001.248z"
              />
            </svg>
            <span
              @click="hidePI"
              class="cursor-pointer text-sm md:text-xl lg:text-2xl xl:text-2xl font-medium pl-2"
              >Pérdida de Ingresos</span
            >
          </div>
        </div>
      </div>

      <div class="container bg-white rounded-lg mt-5 box-shadow flex-col">
        <p class="text-2xl m-0 text-center text-gray-800">Suma asegurada total:</p>
        <p class="text-4xl text-center text-green-500 italic font-black">
          {{ $filters.toCurrency(sumAssuredTotal) }}
        </p>
        <p class="text-xl m-0 text-center text-gray-800">
          Prima quincenal total:
        </p>
        <p class="text-2xl text-center text-green-500 italic">
          {{ $filters.toCurrency(primaQuincenalTotal) }}
        </p>
        <div class="w-full text-center">
          <button
            @click="registerNewQuote"
            class="w-full flex items-center justify-center mx-auto  md:w-2/5 lg:w-2/5 xl:w-2/5 bg-orange-600 hover:bg-orange-700 text-2xl text-white font-bold py-2 px-6 rounded"
          >
            Contratar <mdicon name="chevron-right" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import Swal from "sweetalert2";
import emptyPolicy from "../assets/EmptyPolicy.json";
import Loading from 'vue-loading-overlay';




export default {
  name: "Benefit",
  components: {Loading},
  data() {
    return {
      isLoading: false,
      policy: null,
      age: null,
      reference: null,
      section: null,
      showAP: false,
      showIC: false,
      showRH: false,
      showIE: false,
      showPI: false,
      canContractAP: false,
      canContractIC: false,
      canContractRH: false,
      canContractIE: false,
      canContractPI: false,
      selectedAPCoverage: [],
      selectedICCoverage: [],
      selectedRHCoverage: [],
      selectedIECoverage: [],
      selectedPICoverage: [],
      benefitsAP: [],
      benefitsIC: [],
      benefitsRH: [],
      benefitsIE: [],
      benefitsPI: [],
      contractAP: false,
      listaBeneficios: null,
      jsonLength: null,
      finalJSON: [],
      formula: null,
      protated_cost_plan_a_AP: 0,
      protated_cost_plan_b_AP: 0,
      plan_a_number_AP: 0,
      plan_b_number_AP: 0,
      admin_cost_plan_a_AP: 0,
      admin_cost_plan_b_AP: 0,
      protated_cost_plan_a_IC: 0,
      protated_cost_plan_b_IC: 0,
      plan_a_number_IC: 0,
      plan_b_number_IC: 0,
      admin_cost_plan_a_IC: 0,
      admin_cost_plan_b_IC: 0,
      protated_cost_plan_a_RH: 0,
      protated_cost_plan_b_RH: 0,
      plan_a_number_RH: 0,
      plan_b_number_RH: 0,
      admin_cost_plan_a_RH: 0,
      admin_cost_plan_b_RH: 0,
      protated_cost_plan_a_IE: 0,
      protated_cost_plan_b_IE: 0,
      plan_a_number_IE: 0,
      plan_b_number_IE: 0,
      admin_cost_plan_a_IE: 0,
      admin_cost_plan_b_IE: 0,
      protated_cost_plan_a_PI: 0,
      protated_cost_plan_b_PI: 0,
      plan_a_number_PI: 0,
      plan_b_number_PI: 0,
      admin_cost_plan_a_PI: 0,
      admin_cost_plan_b_PI: 0,
      valueAP: 0,
      valueIC: 0,
      valueRH: 0,
      valueIE: 0,
      valuePI: 0,
      api_lineamagisterialproducts:
        process.env.VUE_APP_APILINEAMAGISTERIALPRODUCTS,
      api_CABSACORE: process.env.VUE_APP_APICABSACORE,
      ccapi: process.env.VUE_APP_CCAPI,
      token_auth: ""
    };
  },
  created() {
    this.isLoading = true;
    this.getTokenAuth();
    this.getDataFromLocalStore();
    this.getCanContract();
    this.getCantContract();
    this.getListOfBenefitsAP();
    this.getListOfBenefitsIC();
    this.getListOfBenefitsRH();
    this.getListOfBenefitsIE();
    this.getListOfBenefitsPI();
    this.getFormulaforCalculteAdminCost();
  },
  methods: {
    async getTokenAuth(){
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      let data = {
        user: {
          email: "aplm@gcabsa.com.mx",
          password: "cabsa2022",
        },
      };

      await axios.post(this.ccapi + "/fas/login", data, config).then((dataa) => {
        this.token_auth = dataa.data.token_auth;
      });
    },
    getFormulaforCalculteAdminCost() {
      axios
        .get(this.ccapi+"/get_formula_cost_administrative", {
          params: {
            token_auth: this.token_auth,
            name_section: this.sectionDescription,
            type_policy: "seguro",
            type_payment: this.payment_type.replaceAll("Ó","O").replaceAll("%",""),
            config: "calcular",
          },
        })
        .then((response) => {
          this.formula = response.data.formula;
        })
        .catch((error) => {
          console.log("Se presento un error: ", error);
        });
    },
    getDataFromLocalStore() {
      this.age = localStorage.age;
      this.reference = localStorage.reference;
      this.section = localStorage.section;
      this.sectionDescription = localStorage.sectionDescription;
      this.kinship = localStorage.kinship;
      this.maritalStatus = localStorage.maritalStatus;
      this.payment_type = localStorage.payment_type;
    },
    getCantContract() {
      if (
        !this.canContractAP &&
        !this.canContractIC &&
        !this.canContractRH &&
        !this.canContractIE &&
        !this.canContractPI
      ) {
        Swal.fire(
          "Cobertura no disponible",
          "Los datos ingresados no coinciden con las requisitos necesarios.",
          "info"
        );
        this.$router.push({ name: "home" });
      }
    },
    getCanContract() {
      // La cobertura Accidentes Personales solo se debe mostrar si la edad es menor o igual a 69 años
      if (this.age <= 69) {
        // La cobertura Accidentes personales no se debe mostrar para dependientes económicos
        if (this.kinship == "Titular" && this.age > 16) {
          this.canContractAP = true;
        }
      }

      // La cobertura Cáncer solo se debe mostrar si la edad es menor o igual a 69 años
      if (this.age <= 69) {
        // Cotizar para mi
        if (this.kinship == "Titular" && this.age > 16) {
          this.canContractIC = true;
        }
        //La cobertura Cáncer solo se deben mostrar para un dependiente económico “Hijo” si es menor o igual a 25 años.
        if (this.kinship == "Hijo(a)" && this.age <= 25) {
          this.canContractIC = true;
        }
        // La cobertura Cáncer solo se debe mostrar para dependiente económico “cónyuge” si la edad es menor o igual a 16 años y el estado civil del titular es “Casado” ó “Concubinato”
        if (
          (this.kinship == "Cónyugue" &&
            this.maritalStatus == "Casado(a)" &&
            this.age > 16) ||
          (this.kinship == "Cónyugue" &&
            this.maritalStatus == "Concubinato" &&
            this.age > 16)
        ) {
          this.canContractIC = true;
        }
        // La cobertura Cáncer solo se debe mostrar para dependiente económico “Padres” si la edad es menor o igual a 69 años y el estado civil del titular es “Soltero”
        if (this.kinship == "Padres" && this.maritalStatus == "Soltero(a)") {
          this.canContractIC = true;
        }
      }

      // // La cobertura Respaldo Hospitalario solo se debe mostrar si la edad es menor o igual a 64 años
      if (/*this.age >= 15 &&*/ this.age < 69) {
        // Cotizar para mi
        if (this.kinship == "Titular" && this.age > 16) {
          this.canContractRH = true;
        }
        // La cobertura Respaldo Hospitalario solo se deben mostrar para un dependiente económico “Hijo” si es menor o igual a 25 años
        if (this.kinship == "Hijo(a)" && this.age <= 25) {
          this.canContractRH = true;
        }
        // La cobertura Respaldo Hospitalario solo se debe mostrar para dependiente económico “cónyuge” si la edad es mayor a 16 años y el estado civil del titular es “Casado” ó “Concubinato”
        if (
          (this.kinship == "Cónyugue" &&
            this.maritalStatus == "Casado(a)" &&
            this.age > 16) ||
          (this.kinship == "Cónyugue" &&
            this.maritalStatus == "Concubinato" &&
            this.age > 16)
        ) {
          this.canContractRH = true;
        }
        // La cobertura Respaldo Hospitalario solo se debe mostrar para dependiente económico “Padres” si la edad es menor o igual a 64 años y el estado civil del titular es “Soltero”
        if (this.kinship == "Padres" && this.maritalStatus == "Soltero(a)") {
          this.canContractRH = true;
        }
      }

      // // La cobertura Enfermedades Graves solo se debe mostrar si la edad es menor o igual a 64 años
      if (this.age <= 64) {
        // Cotizar para mi
        if (this.kinship == "Titular" && this.age > 16) {
          this.canContractIE = true;
        }
        //La cobertura Enfermedades Graves solo se deben mostrar para un dependiente económico “Hijo” si es menor o igual a 25 años
        if (this.kinship == "Hijo(a)" && this.age <= 25) {
          this.canContractIE = true;
        }
        // La cobertura Enfermedades Graves solo se debe mostrar para dependiente económico “cónyuge” si la edad es mayor a 16 años y el estado civil del titular es “Casado” ó “Concubinato”
        if (
          (this.kinship == "Cónyugue" &&
            this.maritalStatus == "Casado(a)" &&
            this.age > 16) ||
          (this.kinship == "Cónyugue" &&
            this.maritalStatus == "Concubinato" &&
            this.age > 16)
        ) {
          this.canContractIE = true;
        }
        // La cobertura Enfermedades Graves solo se debe mostrar para dependiente económico “Padres” si la edad es menor o igual a 64 años y el estado civil del titular es “Soltero”
        if (this.kinship == "Padres" && this.maritalStatus == "Soltero(a)") {
          this.canContractIE = true;
        }
      }

      // // La cobertura Perdida de ingresos solo se debe mostrar si la edad es mayor a 16 años
      // // La cobertura Perdida de ingresos solo se debe mostrar si la edad es menor o igual a 64 años
      if (this.age > 16 && this.age <= 64) {
        // La cobertura Perdida de ingresos no se debe mostrar para dependientes económicos
        if (this.kinship == "Titular") {
          this.canContractPI = true;
        }
      }
    },
    getListOfBenefitsAP() {
      if (this.canContractAP == true) {
        axios
          .get(this.api_lineamagisterialproducts + "/quoter/list_of_benefits", {
            params: {
              product_id: 1,
              age: this.age,
            },
          })
          .then((response) => {
            this.benefitsAP = response.data;
            for (let i = 0; i < this.benefitsAP.result.length; i++) {
              this.benefitsAP.result[i].positionArray = i;
            }
          })
          .catch((error) => {
            console.log("Se presento un error: ", error);
          });
      }
    },
    getListOfBenefitsIC() {
      if (this.canContractIC == true) {
        axios
          .get(this.api_lineamagisterialproducts + "/quoter/list_of_benefits", {
            params: {
              product_id: 2,
              age: this.age,
            },
          })
          .then((response) => {
            this.benefitsIC = response.data;
            for (let i = 0; i < this.benefitsIC.result.length; i++) {
              this.benefitsIC.result[i].positionArray = i;
            }
          });
      }
    },
    getListOfBenefitsRH() {
      if (this.canContractRH == true) {
        axios
          .get(this.api_lineamagisterialproducts + "/quoter/list_of_benefits", {
            params: {
              product_id: 3,
              age: this.age,
            },
          })
          .then((response) => {
            this.benefitsRH = response.data;
            for (let i = 0; i < this.benefitsRH.result.length; i++) {
              this.benefitsRH.result[i].positionArray = i;
            }
          });
      }
    },
    getListOfBenefitsIE() {
      if (this.canContractIE == true) {
        axios
          .get(this.api_lineamagisterialproducts + "/quoter/list_of_benefits", {
            params: {
              product_id: 4,
              age: this.age,
            },
          })
          .then((response) => {
            this.benefitsIE = response.data;
            for (let i = 0; i < this.benefitsIE.result.length; i++) {
              this.benefitsIE.result[i].positionArray = i;
            }
          });
      }
    },
    getListOfBenefitsPI() {
      if (this.canContractPI == true) {
        axios
          .get(this.api_lineamagisterialproducts + "/quoter/list_of_benefits", {
            params: {
              product_id: 5,
              age: this.age,
            },
          })
          .then((response) => {
            this.benefitsPI = response.data;
            for (let i = 0; i < this.benefitsPI.result.length; i++) {
              this.benefitsPI.result[i].positionArray = i;
            }
          })
          .catch((error) => {
            console.log("Se presento un error: ", error);
          })
          .finally(() => (this.isLoading = false));
      }
    },
    hideAP() {
      this.showAP = !this.showAP;
    },
    hideIC() {
      this.showIC = !this.showIC;
    },
    hideRH() {
      this.showRH = !this.showRH;
    },
    hideIE() {
      this.showIE = !this.showIE;
    },
    hidePI() {
      this.showPI = !this.showPI;
    },
    makeJSON() {
      this.finalJSON = [];
      // AP
      // var valueAP = 0;
      var benefitsAPArray = [];
      var benefitAPText;
      var benefitAPValue;
      var benefitAPPlanA;
      var benefitAPPlanB;
      var benefitAPSumAssuredTotal;
      var benefitAPCost;
      var quoteAP;
      var unitCostPlanA;
      var unitCostPlanB;
      var unitCostRoundedPlanA;
      var unitCostRoundedPlanB;

      if (this.selectedAPCoverage != null) {
        if (this.selectedAPCoverage.value >= 0) {
          /*valueAP = Number(
            this.benefitsAP.result[this.selectedAPCoverage.value].costo_total
          );*/

          for (
            let i = 0;
            i <
            this.benefitsAP.result[this.selectedAPCoverage.value].benefits
              .length;
            i++
          ) {
            benefitAPText = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].benefits[i].name;
            benefitAPValue = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].benefits[i].sum_assured;
            benefitAPPlanA = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].plan_a_number;
            benefitAPPlanB = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].plan_b_number;
            benefitAPSumAssuredTotal = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].sum_assured;
            benefitAPCost = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].costo;
            unitCostPlanA = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].costo_plan_a;
            unitCostPlanB = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].costo_plan_b;
            unitCostRoundedPlanA = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].costo_redondeado_plan_a;
            unitCostRoundedPlanB = this.benefitsAP.result[
              this.selectedAPCoverage.value
            ].costo_redondeado_plan_b;

            benefitsAPArray.push({
              plan_a: benefitAPPlanA,
              plan_b: benefitAPPlanB,
              sum_assured: benefitAPSumAssuredTotal,
              price: benefitAPCost,
              unit_cost_plan_a: Number(unitCostPlanA).toFixed(2),
              unit_cost_plan_b: Number(unitCostPlanB).toFixed(2),
              unit_cost_plan_a_rounded: Number(unitCostRoundedPlanA).toFixed(2),
              unit_cost_plan_b_rounded: Number(unitCostRoundedPlanB).toFixed(2),
              unit_cost_plan_a_prorated: this.protated_cost_plan_a_AP,
              unit_cost_plan_b_prorated: this.protated_cost_plan_b_AP,
              admin_cost_plan_a: this.admin_cost_plan_a_AP,
              admin_cost_plan_b: this.admin_cost_plan_b_AP,
              benefits: { name: benefitAPText, sum_assured: benefitAPValue },
            });
          }
          quoteAP = {
            cost: this.valueAP,
            age: this.age,
            product_name: "Accidentes Personales",
            referenced: this.reference,
            benefits: benefitsAPArray,
            product_id: 1,
            client_id: 1,
            bussines_id: this.section,
          };
          this.finalJSON.push(quoteAP);
          this.contractAP = true;
          localStorage.setItem("contractAP", this.contractAP);
        } else {
          this.contractAP = false;
        }
      }

      // IC
      //var valueIC = 0;
      var benefitsICArray = [];
      var benefitICText;
      var benefitICValue;
      var benefitICPlanA;
      var benefitICPlanB;
      var benefitICSumAssuredTotal;
      var benefitICCost;
      var quoteIC;
      var unitCostICPlanA;
      var unitCostICPlanB;
      var unitCostICRoundedPlanA;
      var unitCostICRoundedPlanB;

      if (this.selectedICCoverage != null) {
        if (this.selectedICCoverage.value >= 0) {
          /*valueIC = Number(
            this.benefitsIC.result[this.selectedICCoverage.value].costo_total
          );*/

          for (
            let i = 0;
            i <
            this.benefitsIC.result[this.selectedICCoverage.value].benefits
              .length;
            i++
          ) {
            benefitICText = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].benefits[i].name;
            benefitICValue = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].benefits[i].sum_assured;
            benefitICPlanA = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].plan_a_number;
            benefitICPlanB = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].plan_b_number;
            benefitICSumAssuredTotal = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].sum_assured;
            benefitICCost = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].costo;
            unitCostICPlanA = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].costo_plan_a;
            unitCostICPlanB = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].costo_plan_b;
            unitCostICRoundedPlanA = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].costo_redondeado_plan_a;
            unitCostICRoundedPlanB = this.benefitsIC.result[
              this.selectedICCoverage.value
            ].costo_redondeado_plan_b;

            benefitsICArray.push({
              benefits: { name: benefitICText, sum_assured: benefitICValue },
              plan_a: benefitICPlanA,
              plan_b: benefitICPlanB,
              sum_assured: benefitICSumAssuredTotal,
              cost: benefitICCost,
              unit_cost_plan_a: Number(unitCostICPlanA).toFixed(2),
              unit_cost_plan_b: Number(unitCostICPlanB).toFixed(2),
              unit_cost_plan_a_rounded: Number(unitCostICRoundedPlanA).toFixed(
                2
              ),
              unit_cost_plan_b_rounded: Number(unitCostICRoundedPlanB).toFixed(
                2
              ),
              unit_cost_plan_a_prorated: this.protated_cost_plan_a_IC,
              unit_cost_plan_b_prorated: this.protated_cost_plan_b_IC,
              admin_cost_plan_a: this.admin_cost_plan_a_IC,
              admin_cost_plan_b: this.admin_cost_plan_b_IC,
            });
          }
          quoteIC = {
            cost: this.valueIC,
            age: this.age,
            product_name: "Indemnización por Cáncer",
            referenced: this.reference,
            benefits: benefitsICArray,
            product_id: 2,
            client_id: 1,
            bussines_id: this.section,
          };
          this.finalJSON.push(quoteIC);
        }
      }

      // RH
      //var valueRH = 0;
      var benefitsRHArray = [];
      var benefitRHText;
      var benefitRHValue;
      var benefitRHPlanA;
      var benefitRHPlanB;
      var benefitRHSumAssuredTotal;
      var benefitRHCost;
      var quoteRH;
      var unitCostRHPlanA;
      var unitCostRHPlanB;
      var unitCostRHRoundedPlanA;
      var unitCostRHRoundedPlanB;

      if (this.selectedRHCoverage != null) {
        if (this.selectedRHCoverage.value >= 0) {
          /*valueRH = Number(
            this.benefitsRH.result[this.selectedRHCoverage.value].costo_total
          );*/

          for (
            let i = 0;
            i <
            this.benefitsRH.result[this.selectedRHCoverage.value].benefits
              .length;
            i++
          ) {
            benefitRHText = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].benefits[i].name;
            benefitRHValue = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].benefits[i].sum_assured;
            benefitRHPlanA = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].plan_a_number;
            benefitRHPlanB = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].plan_b_number;
            benefitRHSumAssuredTotal = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].sum_assured;
            benefitRHCost = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].costo;
            unitCostRHPlanA = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].costo_plan_a;
            unitCostRHPlanB = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].costo_plan_b;
            unitCostRHRoundedPlanA = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].costo_redondeado_plan_a;
            unitCostRHRoundedPlanB = this.benefitsRH.result[
              this.selectedRHCoverage.value
            ].costo_redondeado_plan_b;

            benefitsRHArray.push({
              benefits: { name: benefitRHText, sum_assured: benefitRHValue },
              plan_a: benefitRHPlanA,
              plan_b: benefitRHPlanB,
              sum_assured: benefitRHSumAssuredTotal,
              cost: benefitRHCost,
              unit_cost_plan_a: Number(unitCostRHPlanA).toFixed(2),
              unit_cost_plan_b: Number(unitCostRHPlanB).toFixed(2),
              unit_cost_plan_a_rounded: Number(unitCostRHRoundedPlanA).toFixed(
                2
              ),
              unit_cost_plan_b_rounded: Number(unitCostRHRoundedPlanB).toFixed(
                2
              ),
              unit_cost_plan_a_prorated: this.protated_cost_plan_a_RH,
              unit_cost_plan_b_prorated: this.protated_cost_plan_b_RH,
              admin_cost_plan_a: this.admin_cost_plan_a_RH,
              admin_cost_plan_b: this.admin_cost_plan_b_RH,
            });
          }
          quoteRH = {
            cost: this.valueRH,
            age: this.age,
            product_name: "Respaldo Hospitalario",
            referenced: this.reference,
            benefits: benefitsRHArray,
            product_id: 3,
            client_id: 1,
            bussines_id: this.section,
          };
          this.finalJSON.push(quoteRH);
        }
      }
      // IE
      //var valueIE = 0;
      var benefitsIEArray = [];
      var benefitIEText;
      var benefitIEValue;
      var benefitIEPlanA;
      var benefitIEPlanB;
      var benefitIESumAssuredTotal;
      var benefitIECost;
      var quoteIE;
      var unitCostIEPlanA;
      var unitCostIEPlanB;
      var unitCostIERoundedPlanA;
      var unitCostIERoundedPlanB;

      if (this.selectedIECoverage != null) {
        if (this.selectedIECoverage.value >= 0) {
          /*valueIE = Number(
            this.benefitsIE.result[this.selectedIECoverage.value].costo_total
          );*/

          for (
            let i = 0;
            i <
            this.benefitsIE.result[this.selectedIECoverage.value].benefits
              .length;
            i++
          ) {
            benefitIEText = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].benefits[i].name;
            benefitIEValue = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].benefits[i].sum_assured;
            benefitIEPlanA = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].plan_a_number;
            benefitIEPlanB = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].plan_b_number;
            benefitIESumAssuredTotal = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].sum_assured;
            benefitIECost = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].costo;
            unitCostIEPlanA = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].costo_plan_a;
            unitCostIEPlanB = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].costo_plan_b;
            unitCostIERoundedPlanA = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].costo_redondeado_plan_a;
            unitCostIERoundedPlanB = this.benefitsIE.result[
              this.selectedIECoverage.value
            ].costo_redondeado_plan_b;

            benefitsIEArray.push({
              benefits: { name: benefitIEText, sum_assured: benefitIEValue },
              plan_a: benefitIEPlanA,
              plan_b: benefitIEPlanB,
              sum_assured: benefitIESumAssuredTotal,
              cost: benefitIECost,
              unit_cost_plan_a: Number(unitCostIEPlanA).toFixed(2),
              unit_cost_plan_b: Number(unitCostIEPlanB).toFixed(2),
              unit_cost_plan_a_rounded: Number(unitCostIERoundedPlanA).toFixed(
                2
              ),
              unit_cost_plan_b_rounded: Number(unitCostIERoundedPlanB).toFixed(
                2
              ),
              unit_cost_plan_a_prorated: this.protated_cost_plan_a_IE,
              unit_cost_plan_b_prorated: this.protated_cost_plan_b_IE,
              admin_cost_plan_a: this.admin_cost_plan_a_IE,
              admin_cost_plan_b: this.admin_cost_plan_b_IE,
            });
          }
          quoteIE = {
            cost: this.valueIE,
            age: this.age,
            product_name: "Indemnización por Enfermedades Graves",
            referenced: this.reference,
            benefits: benefitsIEArray,
            product_id: 4,
            client_id: 1,
            bussines_id: this.section,
          };
          this.finalJSON.push(quoteIE);
        }
      }

      // PI
      //var valuePI = 0;
      var benefitsPIArray = [];
      var benefitPIText;
      var benefitPIValue;
      var benefitPIPlanA;
      var benefitPIPlanB;
      var benefitPISumAssuredTotal;
      var benefitPICost;
      var quotePI;
      var costUnitPIPlanA;
      var costUnitPIPlanB;
      var unitCostPIRoundedPlanA;
      var unitCostPIRoundedPlanB;

      if (this.selectedPICoverage != null) {
        if (this.selectedPICoverage.value >= 0) {
          /*valuePI = Number(
            this.benefitsPI.result[this.selectedPICoverage.value].costo_total
          );*/

          for (
            let i = 0;
            i <
            this.benefitsPI.result[this.selectedPICoverage.value].benefits
              .length;
            i++
          ) {
            benefitPIText = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].benefits[i].name;
            benefitPIValue = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].benefits[i].sum_assured;
            benefitPIPlanA = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].plan_a_number;
            benefitPIPlanB = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].plan_b_number;
            benefitPISumAssuredTotal = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].sum_assured;
            benefitPICost = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].costo;
            costUnitPIPlanA = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].costo_plan_a;
            costUnitPIPlanB = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].costo_plan_b;
            unitCostPIRoundedPlanA = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].costo_redondeado_plan_a;
            unitCostPIRoundedPlanB = this.benefitsPI.result[
              this.selectedPICoverage.value
            ].costo_redondeado_plan_b;

            benefitsPIArray.push({
              benefits: { name: benefitPIText, sum_assured: benefitPIValue },
              plan_a: benefitPIPlanA,
              plan_b: benefitPIPlanB,
              sum_assured: benefitPISumAssuredTotal,
              cost: benefitPICost,
              unit_cost_plan_a: Number(costUnitPIPlanA).toFixed(2),
              unit_cost_plan_b: Number(costUnitPIPlanB).toFixed(2),
              unit_cost_plan_a_rounded: Number(unitCostPIRoundedPlanA).toFixed(
                2
              ),
              unit_cost_plan_b_rounded: Number(unitCostPIRoundedPlanB).toFixed(
                2
              ),
              unit_cost_plan_a_prorated: this.protated_cost_plan_a_PI,
              unit_cost_plan_b_prorated: this.protated_cost_plan_b_PI,
              admin_cost_plan_a: this.admin_cost_plan_a_PI,
              admin_cost_plan_b: this.admin_cost_plan_b_PI,
            });
          }
          quotePI = {
            cost: this.valuePI,
            age: this.age,
            product_name: "Pérdida de ingresos",
            referenced: this.reference,
            benefits: benefitsPIArray,
            product_id: 5,
            client_id: 1,
            bussines_id: this.section,
          };
          this.finalJSON.push(quotePI);
        }
      }
    },
    registerNewQuote() {
      this.makeJSON();
      localStorage.setItem("jsonWithQuotes", JSON.stringify(this.finalJSON));

      if (this.finalJSON.length >= 1) {
        axios
          .post(this.api_lineamagisterialproducts + "/quoter/register", {
            quotes: this.finalJSON,
          })
          .then((response) => {
            this.addBenefitModel(response.data.result);
            /*Swal.fire(
              "Registro exitoso",
              "Se ha registrado la cotización correctamente.",
              "success"
            );*/
            //this.addBenefitModel();
            this.$router.push({ name: "personal-information" });
          })
          .catch((error) => {
            console.log("Se presento un error: ", error);
          });
      } else {
        Swal.fire(
          "Seleccione una cobertura",
          "Debe seleccionar una cobertura para continuar.",
          "info"
        );
      }
    },
    /*getPolicyFromLocalStorage(){
        this.policy = JSON.parse(localStorage.getItem('policy'))
        this.addBenefitModel(this.policy)
     },*/
    addBenefitModel(data) {
      let kinship = localStorage.getItem("kinship");
      this.policy = JSON.parse(localStorage.getItem("policy"));
      let benefits_temp = [];
      let details_temp = [];
      let detail_temp = {};
      data.forEach((cober) => {
        //este forEach accede a cada cobertura
        detail_temp.product_id = cober.product_id;
        detail_temp.quotation_id = cober.id;
        detail_temp.total_cost = cober.cost;
        detail_temp.age = cober.age;
        detail_temp.product_name = cober.product_name;

        cober.benefits.forEach((details) => {
          // detalles de cada cobertura
          detail_temp.plan_a = details.plan_a;
          detail_temp.plan_b = details.plan_b;
          detail_temp.sum_assured = details.sum_assured;
          detail_temp.unit_cost_plan_a = details.unit_cost_plan_a;
          detail_temp.unit_cost_plan_b = details.unit_cost_plan_b;
          detail_temp.unit_cost_plan_a_rounded =
            details.unit_cost_plan_a_rounded;
          detail_temp.unit_cost_plan_b_rounded =
            details.unit_cost_plan_b_rounded;
          detail_temp.unit_cost_plan_a_prorated =
            details.unit_cost_plan_a_prorated;
          detail_temp.unit_cost_plan_b_prorated =
            details.unit_cost_plan_b_prorated;
          detail_temp.admin_cost_plan_a = details.admin_cost_plan_a;
          detail_temp.admin_cost_plan_b = details.admin_cost_plan_b;

          benefits_temp.push(details.benefits);
        });

        detail_temp.benefits = benefits_temp;
        details_temp.push(detail_temp);
        detail_temp = {};
        benefits_temp = [];
      });

      if (this.policy == null) {
        this.policy = emptyPolicy;
      }
      if (kinship == "Titular") {
        this.policy.client.selected_products.details = details_temp;
        this.policy.client.contractor_insured = true;
        localStorage.setItem("policy", JSON.stringify(this.policy));
      } else {
        this.policy.client.contractor_insured = false;
        localStorage.setItem("policy", JSON.stringify(this.policy));
      }
      localStorage.setItem("details_temp", JSON.stringify(details_temp));
    },
    saveInLocalStorage() {},
    calculateProratedCost(rounded_cost) {
      if (this.payment_type == "NÓMINA 22%") {
        //es mensual
        return Number((((rounded_cost * 24) / 22) * 2).toFixed(2));
      } else {
        return Number(((rounded_cost * 24) / 22).toFixed(2));
      }
    },
    calculateAdminCost(protated_cost) {
      let formul = this.formula;
      if (formul != 0) {
        formul = formul.replaceAll(".round(2)", "");
        formul = formul.replaceAll("eval", "");
        formul = formul.replaceAll("'", "");
        formul = formul.replaceAll("importe", protated_cost);
        formul = Number(eval(formul)).toFixed(2);
        return Number(formul);
      } else {
        return 0;
      }
    },
  },
  computed: {
    sumAssuredTotal() {
      var sum_assured_total;
      var valueAP = 0;
      var valueIC = 0;
      var valueRH = 0;
      var valueIE = 0;
      var valuePI = 0;

      if (this.selectedAPCoverage != null) {
        if (this.selectedAPCoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          valueAP = Number(
            this.benefitsAP.result[this.selectedAPCoverage.value].sum_assured
          );
        }
      }

      if (this.selectedICCoverage != null) {
        if (this.selectedICCoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          valueIC = Number(
            this.benefitsIC.result[this.selectedICCoverage.value].sum_assured
          );
        }
      }

      if (this.selectedRHCoverage != null) {
        if (this.selectedRHCoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          valueRH = Number(
            this.benefitsRH.result[this.selectedRHCoverage.value].sum_assured
          );
        }
      }

      if (this.selectedIECoverage != null) {
        if (this.selectedIECoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          valueIE = Number(
            this.benefitsIE.result[this.selectedIECoverage.value].sum_assured
          );
        }
      }

      if (this.selectedPICoverage != null) {
        if (this.selectedPICoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          valuePI = Number(
            this.benefitsPI.result[this.selectedPICoverage.value].sum_assured
          );
        }
      }

      sum_assured_total = valueAP + valueIC + valueRH + valueIE + valuePI;

      return sum_assured_total.toFixed(2);
    },
    primaQuincenalTotal() {
      var prima_quincenal_total;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.valueAP = 0;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.valueIC = 0;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.valueRH = 0;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.valueIE = 0;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.valuePI = 0;
      //AP*
      if (this.selectedAPCoverage != null) {
        if (this.selectedAPCoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_a_number_AP = this.benefitsAP.result[
            this.selectedAPCoverage.value
          ].plan_a_number;
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_b_number_AP = this.benefitsAP.result[
            this.selectedAPCoverage.value
          ].plan_b_number;

          if (this.plan_a_number_AP > 0) {
            console.log(
              "costo_redondeado_plan_a: ",
              this.benefitsAP.result[this.selectedAPCoverage.value]
                .costo_redondeado_plan_a
            );
            console.log("this.plan_a_number_AP: ", this.plan_a_number_AP);
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_a_AP =
              this.calculateProratedCost(
                this.benefitsAP.result[this.selectedAPCoverage.value]
                  .costo_redondeado_plan_a
              ) * this.plan_a_number_AP;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_a_AP = this.calculateAdminCost(
              this.protated_cost_plan_a_AP
            );
          }

          if (this.plan_b_number_AP > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_b_AP =
              this.calculateProratedCost(
                this.benefitsAP.result[this.selectedAPCoverage.value]
                  .costo_redondeado_plan_b
              ) * this.plan_b_number_AP;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_b_AP = this.calculateAdminCost(
              this.protated_cost_plan_b_AP
            );
          }
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.valueAP = Number(
            this.protated_cost_plan_a_AP +
              this.protated_cost_plan_b_AP +
              this.admin_cost_plan_a_AP +
              this.admin_cost_plan_b_AP
          );
        }
      }
      //IC*
      if (this.selectedICCoverage != null) {
        if (this.selectedICCoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_a_number_IC = this.benefitsIC.result[
            this.selectedICCoverage.value
          ].plan_a_number;

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_b_number_IC = this.benefitsIC.result[
            this.selectedICCoverage.value
          ].plan_b_number;

          if (this.plan_a_number_IC > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_a_IC =
              this.calculateProratedCost(
                this.benefitsIC.result[this.selectedICCoverage.value]
                  .costo_redondeado_plan_a
              ) * this.plan_a_number_IC;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_a_IC = this.calculateAdminCost(
              this.protated_cost_plan_a_IC
            );
          }
          if (this.plan_b_number_IC > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_b_IC =
              this.calculateProratedCost(
                this.benefitsIC.result[this.selectedICCoverage.value]
                  .costo_redondeado_plan_b
              ) * this.plan_b_number_IC;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_b_IC = this.calculateAdminCost(
              this.protated_cost_plan_b_IC
            );
          }

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.valueIC = Number(
            this.protated_cost_plan_a_IC +
              this.protated_cost_plan_b_IC +
              this.admin_cost_plan_a_IC +
              this.admin_cost_plan_b_IC
          );
        }
      }
      //RH*
      if (this.selectedRHCoverage != null) {
        if (this.selectedRHCoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_a_number_RH = this.benefitsRH.result[
            this.selectedRHCoverage.value
          ].plan_a_number;

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_b_number_RH = this.benefitsRH.result[
            this.selectedRHCoverage.value
          ].plan_b_number;

          if (this.plan_a_number_RH > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_a_RH =
              this.calculateProratedCost(
                this.benefitsRH.result[this.selectedRHCoverage.value]
                  .costo_redondeado_plan_a
              ) * this.plan_a_number_RH;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_a_RH = this.calculateAdminCost(
              this.protated_cost_plan_a_RH
            );
          }
          if (this.plan_b_number_RH > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_b_RH =
              this.calculateProratedCost(
                this.benefitsRH.result[this.selectedRHCoverage.value]
                  .costo_redondeado_plan_b
              ) * this.plan_b_number_RH;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_b_RH = this.calculateAdminCost(
              this.protated_cost_plan_b_RH
            );
          }

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.valueRH = Number(
            this.protated_cost_plan_a_RH +
              this.protated_cost_plan_b_RH +
              this.admin_cost_plan_a_RH +
              this.admin_cost_plan_b_RH
          );
        }
      }
      //IE*
      if (this.selectedIECoverage != null) {
        if (this.selectedIECoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_a_number_IE = this.benefitsIE.result[
            this.selectedIECoverage.value
          ].plan_a_number;

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_b_number_IE = this.benefitsIE.result[
            this.selectedIECoverage.value
          ].plan_b_number;

          if (this.plan_a_number_IE > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_a_IE =
              this.calculateProratedCost(
                this.benefitsIE.result[this.selectedIECoverage.value]
                  .costo_redondeado_plan_a
              ) * this.plan_a_number_IE;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_a_IE = this.calculateAdminCost(
              this.protated_cost_plan_a_IE
            );
          }

          if (this.plan_b_number_IE > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_b_IE =
              this.calculateProratedCost(
                this.benefitsIE.result[this.selectedIECoverage.value]
                  .costo_redondeado_plan_b
              ) * this.plan_b_number_IE;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_b_IE = this.calculateAdminCost(
              this.protated_cost_plan_b_IE
            );
          }

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.valueIE = Number(
            this.protated_cost_plan_a_IE +
              this.protated_cost_plan_b_IE +
              this.admin_cost_plan_a_IE +
              this.admin_cost_plan_b_IE
          );
        }
      }
      //PI*
      if (this.selectedPICoverage != null) {
        if (this.selectedPICoverage.value >= 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_a_number_PI = this.benefitsPI.result[
            this.selectedPICoverage.value
          ].plan_a_number;

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.plan_b_number_PI = this.benefitsPI.result[
            this.selectedPICoverage.value
          ].plan_b_number;

          if (this.plan_a_number_PI > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_a_PI =
              this.calculateProratedCost(
                this.benefitsPI.result[this.selectedPICoverage.value]
                  .costo_redondeado_plan_a
              ) * this.plan_a_number_PI;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_a_PI = this.calculateAdminCost(
              this.protated_cost_plan_a_PI
            );
          }

          if (this.plan_b_number_PI > 0) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.protated_cost_plan_b_PI =
              this.calculateProratedCost(
                this.benefitsPI.result[this.selectedPICoverage.value]
                  .costo_redondeado_plan_b
              ) * this.plan_b_number_PI;
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.admin_cost_plan_b_PI = this.calculateAdminCost(
              this.protated_cost_plan_b_PI
            );
          }

          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.valuePI = Number(
            this.protated_cost_plan_a_PI +
              this.protated_cost_plan_b_PI +
              this.admin_cost_plan_a_PI +
              this.admin_cost_plan_b_PI
          );
        }
      }

      prima_quincenal_total =
        this.valueAP +
        this.valueIC +
        this.valueRH +
        this.valueIE +
        this.valuePI;

      return prima_quincenal_total;
    },
    selectAPOptions() {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      if (this.benefitsAP != undefined) {
        return this.benefitsAP.result.map((coverageAP) => ({
          label: formatter.format(coverageAP.sum_assured),
          value: coverageAP.positionArray,
        }));
      } else {
        return false;
      }
    },
    selectICOptions() {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      return this.benefitsIC.result.map((coverageIC) => ({
        label: formatter.format(coverageIC.sum_assured),
        value: coverageIC.positionArray,
      }));
    },
    selectRHOptions() {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      return this.benefitsRH.result.map((coverageRH) => ({
        label: formatter.format(coverageRH.sum_assured),
        value: coverageRH.positionArray,
      }));
    },
    selectIEOptions() {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      return this.benefitsIE.result.map((coverageIE) => ({
        label: formatter.format(coverageIE.sum_assured),
        value: coverageIE.positionArray,
      }));
    },
    selectPIOptions() {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      return this.benefitsPI.result.map((coveragePI) => ({
        label: formatter.format(coveragePI.sum_assured),
        value: coveragePI.positionArray,
      }));
    },
  },
};
</script>

<style scoped>
.box-shadow {
  border: 1px;
  padding: 10px;
  box-shadow: 2px 10px 8px #888888;
}
</style>